import { requests } from "../../api/agent";


export default {
    getContact: () => requests.get('/Contacts/getContacts'),
    setContact: (values) => requests.post("/Contacts/setContacts", values)
};